module.exports = __webpack_public_path__ + "img/new_medical_info_icon.f38c30e.png";